var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import { ElMessage } from 'element-plus';
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { Pagination } from '@/core/enums/Pagination';
import { Actions, Mutations } from '@/store/enums/hrgs/dashboard/ReportEnum';
import { hrgsSwalAlert } from '@/core/helpers/sweet-alert';
import { addingLocalFromUtc, getUtcDifferentWithLocal } from '@/core/helpers/date-format';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    url: `${API_URL}/api/assessments`
};
const initFilter = () => {
    return {
        isCompetent: '',
        userId: '',
        assessmentSchedule: '',
        bnspScheduleCode: '',
        schemeIds: [],
        assessorIds: []
    };
};
let DashboardReportModule = class DashboardReportModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.pageName = 'DashboardReportPage';
        this.loading = false;
        this.modalLoading = false;
        this.dashboardReportList = [];
        this.pagination = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1
        };
        this.filter = initFilter();
    }
    // *GETTERS
    get getDashboardReportList() {
        return this.dashboardReportList;
    }
    get getDashboardReportPagination() {
        return this.pagination;
    }
    get getDashboardReportLoading() {
        return this.loading;
    }
    get getIsDashboardReportListFilter() {
        return this.filter;
    }
    // *MUTATIONS
    [_a = Mutations.SET_LIST](data) {
        this.dashboardReportList = data;
    }
    [_b = Mutations.SET_LOADING](state) {
        this.loading = state;
    }
    [_c = Mutations.SET_PAGINATION_CURRENT_PAGE_CHANGE](data) {
        const totalPage = data.totalItems || 0;
        const totalPageSize = data.pageSize || this.pagination.totalPageSize;
        const currentPage = data.currentPage || this.pagination.currentPage;
        this.pagination = {
            totalPage,
            totalPageSize,
            currentPage,
            startPaginationIndex: 0,
            endPaginationIndex: Math.floor(totalPage / totalPageSize)
        };
    }
    [_d = Mutations.SET_FILTER](data) {
        this.filter = Object.assign(Object.assign({}, this.filter), data);
    }
    [_e = Mutations.CLEAR_FILTER]() {
        this.filter = initFilter();
    }
    // *ACTIONS
    // *GET DASHBOARD REPORT LIST DATA
    [_f = Actions.GET_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ ver: 'v1' }, (this.filter.isCompetent && {
            isCompetent: this.filter.isCompetent
        })), (this.filter.userId && {
            userId: this.filter.userId
        })), (this.filter.assessmentSchedule && {
            startDate: addingLocalFromUtc(this.filter.assessmentSchedule.split(',')[0]),
            endDate: addingLocalFromUtc(this.filter.assessmentSchedule.split(',')[1])
        })), (this.filter.bnspScheduleCode && {
            bnspScheduleCode: this.filter.bnspScheduleCode
        })), { gmt: String(getUtcDifferentWithLocal()), pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO });
        const schemeIds = this.filter.schemeIds.length > 0
            ? `&SchemeIds=${this.filter.schemeIds.join('&SchemeIds=')}`
            : '';
        const assessorIds = this.filter.assessorIds.length > 0
            ? `&AssessorIds=${this.filter.assessorIds.join('&AssessorIds=')}`
            : '';
        this.context.commit(Mutations.SET_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`
        ${API_URLS.url}/${employeeID}/reports?${new URLSearchParams(params).toString() || ''}${schemeIds}${assessorIds}
      `)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_LIST, resData.data);
                this.context.commit(Mutations.SET_PAGINATION_CURRENT_PAGE_CHANGE, {
                    currentPage: params.pageNo,
                    pageSize: params.pageSize,
                    totalItems: resData.totalRecords
                });
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Dashboard Report list.'
                });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_LOADING, false);
            });
        });
    }
    // *EXPORT DASHBOARD REPORT LIST DATA
    [_g = Actions.EXPORT_DASHBOARD_REPORT]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ ver: 'v1' }, (this.filter.isCompetent && {
            isCompetent: this.filter.isCompetent
        })), (this.filter.userId && {
            userId: this.filter.userId
        })), (this.filter.assessmentSchedule && {
            startDate: addingLocalFromUtc(this.filter.assessmentSchedule.split(',')[0]),
            endDate: addingLocalFromUtc(this.filter.assessmentSchedule.split(',')[1])
        })), (this.filter.bnspScheduleCode && {
            bnspScheduleCode: this.filter.bnspScheduleCode
        })), { gmt: String(getUtcDifferentWithLocal()) });
        const schemeIds = this.filter.schemeIds.length > 0
            ? `&SchemeIds=${this.filter.schemeIds.join('&SchemeIds=')}`
            : '';
        const assessorIds = this.filter.assessorIds.length > 0
            ? `&AssessorIds=${this.filter.assessorIds.join('&AssessorIds=')}`
            : '';
        this.context.commit(Mutations.SET_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/reports/export?${new URLSearchParams(params).toString()}${schemeIds}${assessorIds}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                this.context.commit(Mutations.SET_LOADING, false);
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed download template.'
                });
                reject(error);
            });
        });
    }
    // *DOWNLOAD DASHBOARD REPORT LIST DATA
    [_h = Actions.DOWNLOAD_DASHBOARD_REPORT](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            fileName: (payload === null || payload === void 0 ? void 0 : payload.fileName) || ''
        };
        return new Promise((resolve, reject) => {
            ApiService.getBlob(`${API_URLS.url}/${employeeID}/reports/download?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', params.fileName);
                document.body.appendChild(link);
                link.click();
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed download template.'
                });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_LOADING, false);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _e, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _f, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _g, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DashboardReportModule.prototype, _h, null);
DashboardReportModule = __decorate([
    Module
], DashboardReportModule);
export default DashboardReportModule;
